exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.split[data-v-6dc52e36] {\n  width: 50%;\n}\n.flex[data-v-6dc52e36] {\n  align-items: center;\n}\n", ""]);

// exports
